<template>
    <div class="testimonios">
        <div class="ancla" id="testimonios"></div>
        <div class="content">
            <h3>Historias reales de éxito</h3>
            <slick ref="slick" :options="slickOptions">
                <div>
                    <div class="contentTestimonio">
                        <div class="testimonio">
                            <p>Quiero agradecer a Haniel Maldonado ya que es un excelente consultor, con su dedicación y profesionalismo en su taller me ha apoyado en mi crecimiento en el ramo de las ventas, con su experiencia ha logrado que entienda el valor agregado en mi producto y lo valioso que esto representa, con su pasión por las ventas me ayudo a brindar mejores alternativas y herramientas de acuerdo a las necesidades de cada cliente, así como enriquecer mi proceso y estrategia de venta para la obtención de mis mejores resultados.</p>
                            <span>Daniel López</span>
                            <strong>Gte. Ventas de Seminuevos IBC</strong>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="contentTestimonio">
                        <div class="testimonio">
                            <p>Como directivos debemos tener en mente dos objetivos principales, que nuestras empresas estén mejor que como las encontramos y que nuestra gente esté mejor que cuando llegamos, estas dos premisas van de la mano, en ese sentido Hanniel Maldonado nos ha ayudado de manera muy profesional a través de la impartición de programas de desarrollo comercial que tienen una metodología bien definida orientada a la profesionalización de nuestra gente y a la búsqueda de mayores ingresos para la compañía.</p>
                            <span>Pavel Vázquez</span>
                            <strong>Gte. Gral. Camiones Vence</strong>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="contentTestimonio">
                        <div class="testimonio">
                            <p>Aprovecho este medio para agradecer totalmente las enseñanzas, técnicas y experiencias que compartiste a lo largo del diplomado para el desarrollo de habilidades para las ventas profesionales, tengo que reconocer que los procesos que definiste ayudan a obtener resultados inmediatos y por ende a mediano /largo plazo. Siendo posible aplicarlos en cualquier producto o servicio que brinde el vendedor.</p>
                            <span>Luis Ley</span>
                            <strong>Gte. Comercial Cemenquin</strong>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="contentTestimonio">
                        <div class="testimonio">
                            <p>Definitivamente me ayudo a proyectar el camino que debía seguir para alcanzar mis objetivos y sobretodo darle importancia a los tiempos establecidos ya que son parte fundamental para hacer eficaz y eficiente el trabajo. Además me enseño que el compromiso y la disciplina que dedique a cada una de mis tareas serán el resultado de la buena administración de mi energía.</p>
                            <span>Alexia Negrete</span>
                            <strong>L.M. Piú Capital</strong>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="contentTestimonio">
                        <div class="testimonio">
                            <p>He tenido la oportunidad de trabajar con Hanniel durante varios años, lo conozco como empleado y como consultor. Hanniel es un excelente ejemplo de lo que puede ser una persona profesional, tiene mucha experiencia en ventas y asuntos relacionados con negocios, es la persona de ventas más informada y estructurada que conozco, está comprometida a mejorar continuamente.</p>
                            <span>Sergio Ahumada</span>
                            <strong>CEO Lorian Health San Diego Cal.</strong>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="contentTestimonio">
                        <div class="testimonio">
                            <p>Con su dedicación y profesionalismo, no solo ha apoyado a distintas empresas con capacitación en el ramo de las ventas, sino con un compromiso más amplio al ponerse a disponibilidad de quienes lo conocen para un apoyo personalizado. Es elemento valioso entre nuestros capacitadores de cabecera y será un gusto volver a convocarlo para que comparta sus experiencias.</p>
                            <span>Sara Moreno</span>
                            <strong>Coparmex</strong>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="contentTestimonio">
                        <div class="testimonio">
                            <p>Hanniel es un profesional verdaderamente experto en ventas. Con un enfoque claro y práctico ayuda a las empresas a llevar a otro nivel sus habilidades comerciales, así como preparar poderosos sistemas de venta. Muy recomendado, genial persona!!!!!</p>
                            <span>Andrea Pallares</span>
                            <strong>Fundadora Smartup Speaker</strong>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="contentTestimonio">
                        <div class="testimonio">
                            <p>Curso muy aterrizado a la realidad. Todos los participantes mostraron mucho interés. Se pudieron aplicar muchas estrategias a las actividades diarias. Excelente seguimiento postventa.</p>
                            <span>Lizeth González</span>
                            <strong>Ger. Comercial Becerril Refrigeración</strong>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="contentTestimonio">
                        <div class="testimonio">
                            <p>Hanniel Maldonado, con una metodología muy peculiar ha logrado que sus clientes entiendan el valor agregado de sentar las bases de un programa de ventas, que realmente involucres a toda la organización, que sea medible y sobre todo rentable.</p>
                            <span>Alejandro Castañeda</span>
                            <strong>CEO Factor Mercadotecnia</strong>
                        </div>
                    </div>
                </div>
            </slick>
        </div>
    </div>
</template>

<script>
    import Slick from 'vue-slick'
    export default {
        components: {
            Slick
        },
        data() {
            return {
                slickOptions: {
                    slidesToShow: 2,
                    dots: true,
                    arrows: false,
                    autoplay: true,
                    slidesToScroll: 2,
                    responsive: [
                        {
                        breakpoint: 767,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }
                    ]
                },
            };
        },
        methods: {
            next() {
                this.$refs.slick.next()
            },
            prev() {
                this.$refs.slick.prev()
            },
            reInit() {
                this.$refs.slick.reSlick()
            }
        }
    }
</script>

<style scoped>
    .testimonios{
        padding: 100px 0 124px 0;
        position: relative;
    }
    h3{
        margin-bottom: 30px!important;
    }
    .contentTestimonio{
        padding: 30px;
    }
    .testimonio{
        background: url('../assets/img/icn_quote1.svg') 8% 15%/80px no-repeat, url('../assets/img/icn_quote2.svg') 92% 85%/80px no-repeat;
        /* background-color: #000000; */
        padding: 40px;
        -webkit-box-shadow: 0px 0px 30px 0px rgba(229,229,229,1);
        -moz-box-shadow: 0px 0px 30px 0px rgba(229,229,229,1);
        box-shadow: 0px 0px 30px 0px rgba(229,229,229,1);
    }
    .testimonio *{
        font-size: 10pt;
    }
    p{
        margin-bottom: 30px;
    }
    strong{
        display: block;
        color: #EC4802;
    }

    @media screen and (max-width: 767px){
        .testimonios{
            padding: 80px 0 104px 0;
        }
        .contentTestimonio{
            padding: 0 15px;
        }
        .testimonio{
            padding: 40px 20px;
        }
    }
</style>

<style>
    .testimonios .slick-dots li, .testimonios .slick-dots li button{
        width: 25px;
        height: 3px;
    }
    .testimonios .slick-dots li button:before{
        content: url('../assets/img/icn_line_white.png');
        opacity: 1;
    }
    .testimonios .slick-dots li.slick-active button:before{
        content: url('../assets/img/icn_line_orange.png');
    }
</style>


// WEBPACK FOOTER //
// src/components/Testimonios.vue